<template>
  <div class="old-globals">
    <form @submit.prevent="signup">
      <md-card class="gray-1 bg">
        <md-progress-bar v-if="loading" md-mode="query" />
        <md-card-header>
          <div class="md-layout md-alignment-center-center header-content">
            <img class="logo" alt="VRpatients Logo" src="../../../assets/images/VRP_Logo.png">
          </div>
        </md-card-header>
        <md-card-content>
          <div v-if="error" class="form-error">{{ error.message || error.error || error }}</div>
          <md-field>
            <md-input v-model.trim="state.user.email" type="email" placeholder="Email" :disabled="true" required />
          </md-field>
          <md-field>
            <md-input v-model.trim="state.user.given_name" placeholder="First Name" :disabled="true" required />
          </md-field>
          <md-field>
            <md-input v-model.trim="state.user.family_name" placeholder="Last Name" :disabled="true" required />
          </md-field>
          <md-field>
            <md-input
              v-model="state.user.password"
              type="password"
              placeholder="Password"
              required
            />
          </md-field>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button type="submit" class="md-raised md-primary" :disabled="loading">Choose Password</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import jwt_decode from 'jwt-decode';

export default {
  name: 'choose-password-form',
  props: {
    loading: {
      type: Boolean,
    },
    error: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      state: {
        user: {
          email: '',
          password: '',
          given_name: '',
          family_name: '',
        },
        token: null,
        decodedToken: null
      },
    };
  },
  computed: {
  },
  mounted() {
    const token = this.$route.query.token;
    if (token) {
      this.state.token = token;
      const decodedToken = jwt_decode(token);
      this.state.user.email = decodedToken.user.email;
      this.state.user.given_name = decodedToken.user.given_name;
      this.state.user.family_name = decodedToken.user.family_name;
      this.state.decodedToken = decodedToken;
    } else {
      this.state.token = null;
      this.state.decodedToken = null;
      this.$emit('setError', 'Error: Missing token');
    }
  },
  methods: {
    signup() {
      this.state.user.email = this.state.user.email.toLowerCase();
      this.$emit('signup', this.state.user, this.state.token, this.state.decodedToken);
    },
  },
};
</script>

<style>
.header-content {
  flex-direction: column;
}
.logo {
  max-width: 100px;
}
</style>
